export default {
  meta: {
    title: '商圈详情',
    url: '/iterate/siteselectionmapdetail', // 埋点字段，上报归属的模块
    urlName: '商圈详情' // 埋点字段，上报归属的模块
  }
};
